/* =====================================================
   Section : Page Newsletter — FOG
   Soumission AJAX vers l'endpoint maison (inscription Brevo).
   Capture nom/societe + email + pays + activite + langue, honeypot, etats succes/erreur.
   ===================================================== */

(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* Libelles : snippets/i18n-js.liquid (window.FOG_I18N, charge avant ce script
     par layout/theme.liquid). Lu a l'appel, jamais en dur. Spec 07. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  function initForm(form) {
    var endpoint = form.getAttribute('data-endpoint');
    if (!endpoint) return;

    var nameInput = form.querySelector('[name="name"]');
    var emailInput = form.querySelector('[name="email"]');
    var countrySelect = form.querySelector('[name="country"]');
    var activitySelect = form.querySelector('[name="activity"]');
    var languageSelect = form.querySelector('[name="language"]');
    var consentInput = form.querySelector('[name="consent"]');
    var honeypot = form.querySelector('[name="company_url"]');
    var submitBtn = form.querySelector('[data-newsletter-submit]');
    var submitLabel = form.querySelector('.newsletter-page__submit-label');
    var successBox = form.querySelector('[data-newsletter-success]');
    var errorBox = form.querySelector('[data-newsletter-error]');
    var errorText = errorBox ? errorBox.querySelector('p') : null;
    var genericError = form.getAttribute('data-error-text') || i18n('pages.newsletter.error_generic_short');

    function showError(msg) {
      if (!errorBox) return;
      if (errorText) errorText.textContent = msg;
      errorBox.hidden = false;
    }
    function clearError() {
      if (errorBox) errorBox.hidden = true;
    }

    function setLoading(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      if (submitLabel) submitLabel.textContent = on ? i18n('pages.newsletter.sending') : (submitBtn.getAttribute('data-label') || submitLabel.textContent);
    }

    // Memorise le libelle initial du bouton
    if (submitLabel) submitBtn.setAttribute('data-label', submitLabel.textContent);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      // Honeypot : si rempli, on simule un succes sans rien envoyer
      if (honeypot && honeypot.value.trim() !== '') {
        showSuccess();
        return;
      }

      var name = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var country = countrySelect ? countrySelect.value : '';
      var activity = activitySelect ? activitySelect.value : '';
      var language = languageSelect ? languageSelect.value : '';

      if (nameInput && !name) {
        showError(i18n('pages.newsletter.error_name'));
        nameInput.focus();
        return;
      }
      if (!EMAIL_RE.test(email)) {
        showError(i18n('pages.newsletter.error_email'));
        if (emailInput) emailInput.focus();
        return;
      }
      if (countrySelect && !country) {
        showError(i18n('pages.newsletter.error_country'));
        countrySelect.focus();
        return;
      }
      if (activitySelect && !activity) {
        showError(i18n('pages.newsletter.error_activity'));
        activitySelect.focus();
        return;
      }
      if (languageSelect && !language) {
        showError(i18n('pages.newsletter.error_language'));
        languageSelect.focus();
        return;
      }
      if (consentInput && !consentInput.checked) {
        showError(i18n('pages.newsletter.error_consent'));
        consentInput.focus();
        return;
      }

      var payload = {
        name: name,
        email: email,
        country: country,
        activity: activity,
        language: language,
        company_url: honeypot ? honeypot.value : ''
      };

      setLoading(true);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (r.ok && r.data && r.data.ok) {
            showSuccess();
          } else {
            setLoading(false);
            showError((r.data && r.data.error) ? r.data.error : genericError);
          }
        })
        .catch(function () {
          setLoading(false);
          showError(genericError);
        });
    });

    function showSuccess() {
      clearError();
      form.classList.add('is-submitted');
      if (successBox) {
        successBox.hidden = false;
        if (typeof successBox.focus === 'function') {
          successBox.setAttribute('tabindex', '-1');
          successBox.focus();
        }
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-newsletter-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
